// ANCHOR Model
import { createSelector, createStateModel } from 'react-scoped-model';

export const FormQuestionActive = createStateModel<string | undefined>(undefined, {
  displayName: 'Models.FormQuestionActive',
});

export const useFormQuestionActiveValue = createSelector(
  FormQuestionActive,
  (store) => store[0],
);

export const useFormQuestionActiveDispatch = createSelector(
  FormQuestionActive,
  (store) => store[1],
);
